// src/api/maintenance/maintenanceDetailsApi.js
import axiosInstance from '../axiosInstance';

export const fetchMaintenanceDetails = async ({ manId, page, limit, estreg }) => {
  const params = {};
  if (page != null) params.page = page;
  if (limit != null) params.limit = limit;
  if (estreg) params.estreg = estreg; // 'A' | 'I' | 'E'

  const { data } = await axiosInstance.get(`/maintenance/records/${manId}/details`, { params });
  return data; // { items, total, page, limit } o tu shape actual
};

export const fetchMaintenanceDetailById = async ({ manId, detailId }) => {
  const { data } = await axiosInstance.get(`/maintenance/records/${manId}/details/${detailId}`);
  return data;
};

export const createMaintenanceDetail = async ({ manId, payload }) => {
  const { data } = await axiosInstance.post(`/maintenance/records/${manId}/details`, payload);
  return data;
};

export const updateMaintenanceDetail = async ({ manId, detailId, payload }) => {
  const { data } = await axiosInstance.put(
    `/maintenance/records/${manId}/details/${detailId}`,
    payload
  );
  return data;
};

export const deleteMaintenanceDetail = async ({ manId, detailId, updbyid }) => {
  const { data } = await axiosInstance.delete(
    `/maintenance/records/${manId}/details/${detailId}`,
    { data: { updbyid } }
  );
  return data;
};

export const createMaintenanceDetailsBulk = async ({ manId, comids, defaults, crebyid }) => {
  const { data } = await axiosInstance.post(
    `/maintenance/records/${manId}/details/bulk`,
    { comids, defaults, crebyid }
  );
  return data;  // { createdCount, reactivatedCount, skipped, notFound, created }
};

export const fetchDetailDocs = async ({ manId, detailId }) => {
  const { data } = await axiosInstance.get(`/maintenance/documents/${manId}/details/${detailId}/docs`);
  return data;
};

export const uploadDetailDoc = async ({ manId, detailId, payload }) => {
  // payload: { docnom, tipdoc, tipcomid?, file }  -> multipart
  const fd = new FormData();
  fd.append('docnom', payload.docnom);
  fd.append('tipdoc', payload.tipdoc);
  fd.append('crebyid', payload.crebyid);
  if (payload.tipcomid != null) fd.append('tipcomid', payload.tipcomid);
  fd.append('document', payload.file);

  const { data } = await axiosInstance.post(
    `/maintenance/documents/${manId}/details/${detailId}/docs`,
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
};

export const updateDetailDoc = async ({ manId, detailId, docId, formData }) => {
  const { data } = await axiosInstance.put(
    `/maintenance/documents/${manId}/details/${detailId}/docs/${docId}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
};

export const deleteDetailDoc = async ({ manId, detailId, docId }) => {
  const { data } = await axiosInstance.delete(
    `/maintenance/documents/${manId}/details/${detailId}/docs/${docId}`
  );
  return data;
};
